import { render } from "./Rewards.vue?vue&type=template&id=b1d9eb58&scoped=true"
import script from "./Rewards.vue?vue&type=script&lang=ts"
export * from "./Rewards.vue?vue&type=script&lang=ts"

import "./Rewards.vue?vue&type=style&index=0&id=b1d9eb58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1d9eb58"

export default script